import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import {
  logisticsAsset,
  manufacturingSteel,
  manufacturingProcess,
  retailOffice,
  retailExhibition,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/manufacturingSteel/video/rtlsVideo.mp4';

export default {
  desc: 'Trong môi trường kinh doanh hiện đại, quản lý chất lượng và quản lý hàng tồn kho hiệu quả đóng vai trò quan trọng đối với sự thành công của doanh nghiệp. ',
  keywords: 'Quản lý chất lượng, quản lý kho hàng, UWB, RTLS, quan ly chat luong, quan ly kho hang, uwb, rtls.',
  ogSite: 'UWB: Giải pháp cho quản lý chất lượng và quản lý hàng tồn kho',
  title: 'UWB: Giải pháp cho quản lý chất lượng và quản lý hàng tồn kho',
  ogUrl: 'https://orbro.io/vi/blog/qa-uwb',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDlVCtmGkr2mCVSS69T6u1T4F6EZiqevSZ-7cN786FOvXV8x22WHoof7IcLlSW7d3d4DnUPZT2QfBIuUWr_weryhpgDPEa45E1edX4NBzbCnjImjTiKPVNkJrnd-hMccXsYDNleXYSmD_YNZSLPjAwSMKKN90Mx3tpkR9a7UTKQ-cImQeFt0AOvs96-ik71EqDzH3cdqAWsBQ7aU_aLz_wlgsJwZMUUAAPPY7lxS8lWkog24zYM8BWi2P4-bg6lZ0IL5Be72Kuu1Ga2-E828VnyLDcaIkXnXbFqBqFoW57RzNMYcpG-bH3VEhchLwDniUo-jBNqflu56GYJZFz_CMBt-PdbwZEXzyNVxVyomHJgFQ-_tuofm4uNMx6DdvQ3EAbi99lfqXxlwE05tg7IFIIn88NzPmt6B_D-g0Ujw73JyDNlyzOefzda1AisrhVvXXHE12gEZAQEAnDVsf3mDImb9t9WffWNd047vV9q6GWhzE9BNt5ibIfCXZxVJD3Q6xWSICvlyRJdbFKPLMbsjwe07izGimOadYEIgqo7IBq0sH9kw8I0azDR2iJKcAEFexI4TBxg0uvQJRTqbePuIdd8hvDRm7HcFvd3-X8PctgzhJPrN4y7nSMWlWSH77CEDaYptKymzQvANITzUqYwh8_MWoPcMYKdM-3z8fuRhtut9qckVa8HbX0lFmfPE1hci-P_pz7Wx-jCb2pXgdSoVENciMiiHeng7uHM3BtBM0-2GKsCINKIFKGJs8iD-kgEiH8VWr3SkIVWJzkR-Bi63wUR-khcKdv2u2jwsQV0ClNREfUWWQpiEZxfFyw2zK8KMPxRSk4hhKh_hNeIagh-ygtgeLYzblJicZL7Hbl5w7USiFatqiLkaNKzBimapAPyMde_FZuPRAQie5tC95ZtYPRyXGGMGA1qXV7oZ2GpzqwBkG9wU_MTYQDznkHb3cJvSYUWVGT6J704WQWlETRLd2Dl7N60sZ50lDknqhXG1ZfGGF8qcBgIAXqfuUF-nRIYqZqwHoObsg_F_5iBMZzejZ82s1gbIGHR3MKaOqJy2hZOFgZfKdIST5uJHCKvc22R3enzPv502iA-rkaOY5n5fbWlFGYCB7vwvoWYspA8zGdUhQAee4hAWRQrn4L65-tc4n0rKFKBUqDi_tE5q7d9CLdGirQixGEhZc1pP8SOT9wRECaNgtzQjZf5lrjBdtjBR6oi8m6_cDiZsyHY2kZZVIQBodyLG9VToaONzqqNbcfLdQJ9PnDwxV0zS2UV1hpZIJSoCjk3fLgUn_rHE4yBlkubsupv3o4b1uUuWOSmCl2z8Bbowg6pub3WJAQ92GZa9l06BsP8H7wNS5c0B-pMOockKojLd5B-uMVbslrDK1KUS-0_00CRW9N9KzUg0-jtCM62SDPsilmcnPFwxO5bcNMVXCaUwDa5GVDhKgXXsi4aZ5tbkxZhH3RHDPSLjNtVr6KNeUCBt4Nezhhyp3ETy9B9L0m28nYfY5KUDdzpzwo68QW5GQMDP4bn4vq9pl7_oKviMByvEuvJPzi4pa1LZ9HlqTCFEf3RSRvMv_UhyZQ=w1851-h1197',
  ogType: 'website',
  date: '2023-12-18',
  tag1: '#Quanlychatluong',
  tag2: '#Quanlykhohang',
  tag3: '#Uwb',
  tag4: '#Rtls',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Trong môi trường kinh doanh hiện đại, quản lý chất lượng và quản lý hàng tồn kho hiệu quả đóng vai trò quan trọng đối với sự thành công của doanh nghiệp. Với sự ra đời của các công nghệ mới nhất, nhiều giải pháp khác nhau có khả năng cải thiện các quy trình quản lý này đang xuất hiện, và một trong số đó là giải pháp ứng dụng công nghệ UWB (Ultra-Wideband - Băng thông siêu rộng). UWB là công nghệ theo dõi vị trí với độ chính xác cao, có băng thông rất rộng nên có thể cung cấp thông tin vị trí chính xác. Bằng cách áp dụng công nghệ này vào quản lý chất lượng và quản lý hàng tồn kho, doanh nghiệp có thể thu được nhiều lợi ích khác nhau.',
      dot: '',
    },
    {
      head: 'Cung cấp thông tin vị trí với độ chính xác cao',
      subHead: '',
      desc: 'Công nghệ UWB cung cấp thông tin vị trí với độ chính xác cao, do đó doanh nghiệp có thể xác định vị trí của sản phẩm và tài sản với độ chính xác cao. Điều này cho phép theo dõi lộ trình di chuyển của sản phẩm theo thời gian thực và xác định chính xác vị trí của vật thể, giúp vận hành hiệu quả.',
      dot: '',
    },
    {
      head: 'Phát hiện và phân tích dữ liệu theo thời gian thực',
      subHead: '',
      desc: 'Giải pháp UWB thu thập nhiều loại dữ liệu khác nhau theo thời gian thực. Thông qua đó, có thể nhanh chóng phát hiện các vấn đề hoặc thay đổi phát sinh ở mỗi giai đoạn của quy trình sản xuất, và thông qua phân tích dữ liệu, có thể xác định được nguyên nhân gốc rễ của vấn đề. Điều này cho phép phản ứng và cải thiện nhanh chóng, từ đó nâng cao chất lượng sản xuất.',
      dot: '',
    },
    {
      head: 'Nâng cao hiệu quả năng lượng',
      subHead: '',
      desc: 'Công nghệ UWB hoạt động với công suất thấp nhưng vẫn cung cấp độ chính xác cao. Điều này giúp cải thiện hiệu quả năng lượng của toàn bộ hệ thống và có thể kéo dài tuổi thọ pin của thiết bị. Việc nâng cao hiệu quả năng lượng cũng có tác động tích cực đến tính bền vững của doanh nghiệp.',
      dot: '',
    },
    {
      head: 'Kiểm soát thích ứng theo thời gian thực',
      subHead: '',
      desc: 'Giải pháp UWB cho phép kiểm soát thích ứng tự động bằng cách phát hiện và phân tích dữ liệu theo thời gian thực. Điều này giúp tối ưu hóa quy trình làm việc trong dây chuyền sản xuất hoặc nhà kho, và hỗ trợ cải thiện hoạt động trong tương lai thông qua phân tích dự đoán dựa trên dữ liệu quá khứ.',
      dot: '',
    },
    {
      head: 'Tăng cường bảo mật',
      subHead: '',
      desc: 'UWB sử dụng truyền thông không dây và cung cấp mức độ bảo mật cao hơn so với các công nghệ không dây khác. Nó có khả năng nhiễu vật lý rất thấp và đảm bảo truyền thông an toàn, từ đó tăng cường bảo mật tài sản của doanh nghiệp.',
      dot: '',
    },
    {
      head: 'Khả năng tùy chỉnh',
      subHead: '',
      desc: 'Giải pháp UWB có thể áp dụng cho nhiều lĩnh vực công nghiệp khác nhau và có thể được cấu hình tùy chỉnh theo nhu cầu cụ thể của doanh nghiệp. Điều này mang lại sự linh hoạt cho doanh nghiệp trong việc tự cải thiện hệ thống hoặc triển khai các giải pháp được tối ưu hóa cho môi trường hoạt động cụ thể.\nGiải pháp quản lý chất lượng và quản lý hàng tồn kho ứng dụng UWB là một công nghệ đổi mới có thể tăng cường năng lực cạnh tranh của doanh nghiệp và tối đa hóa hiệu quả thông qua nhiều ưu điểm đa dạng.',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng',
      subHead: 'Ngành sản xuất',
      desc: 'Hệ thống theo dõi vị trí thời gian thực sử dụng UWB được dùng để quản lý sản xuất hiệu quả trong ngành sản xuất. Có thể xác định chính xác vị trí của nguyên vật liệu, linh kiện, sản phẩm, v.v., để tối ưu hóa quy trình sản xuất và giảm tỷ lệ phế phẩm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Logistics và Quản lý kho bãi',
      desc: 'Các công ty logistics hoặc kho bãi quy mô lớn có thể tối ưu hóa việc quản lý hàng tồn kho bằng cách triển khai UWB để theo dõi lộ trình di chuyển của hàng hóa theo thời gian thực. Đặc biệt, hệ thống hướng dẫn tự động hóa thông qua UWB trong các kho hàng lớn cho phép bố trí hàng tồn kho một cách hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Lĩnh vực y tế',
      desc: 'Tại các bệnh viện hoặc cơ sở y tế, UWB được sử dụng để xác định chính xác vị trí của thiết bị y tế hoặc bệnh nhân, từ đó có thể cải thiện khả năng ứng phó trong tình huống khẩn cấp hoặc nâng cao chất lượng dịch vụ y tế.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Mua sắm và Bán lẻ',
      desc: 'Trong ngành bán lẻ, UWB được sử dụng để phân tích mô hình di chuyển của khách hàng trong cửa hàng và xác định tình trạng tồn kho sản phẩm theo thời gian thực, qua đó cải thiện việc quản lý hàng tồn kho và trải nghiệm của khách hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành xây dựng',
      desc: 'Tại các công trường xây dựng quy mô lớn, UWB được ứng dụng để xác định chính xác vị trí của thiết bị và công nhân, nhờ đó tăng cường tính an toàn và tối ưu hóa lịch trình công việc.\n\n Những trường hợp này cho thấy công nghệ theo dõi vị trí thông qua UWB đang mang lại kết quả trong nhiều lĩnh vực công nghiệp khác nhau. Nhiều doanh nghiệp đang cải thiện năng suất, hiệu quả và đảm bảo năng lực cạnh tranh bằng cách triển khai các giải pháp UWB. ',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: manufacturingProcess.thumb,
        data: 'manufacturingProcess',
        link: '/vi/enterprise/manufacturing/process',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
